import React, { useState, useEffect } from "react";
import { Container, Grid, InputAdornment, Typography } from "@mui/material";
import { TextField, MenuItem } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { toast } from "react-toastify";

import "../pages/styles/RuleCheckPoint.css";
import TableContainer from "../components/scripts/TableContainer";
import requests from "../utility/Requests";

function RuleCheckPoint() {
  const [ruleCheckPoint, setRuleCheckPoint] = useState([]);
  const [rulelist, setRulelist] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [checkpoint, setCheckpoint] = useState();
  const [title, setTitle] = useState();
  const [selectedRuleID, setSelectedRuleID] = useState();
  const [checkpointTarget, setCheckpointTarget] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {};

  const columns = [
    {
      Header: "S.No.",
      accessor: "",
      Cell: (props) => {
        console.log("props", props);
        return <p>{+props.row.id + 1}</p>;
      },
    },
    {
      Header: "Rules to Execute",
      accessor: "RuleTitle_CR",
    },
    {
      Header: "Action",
      accessor: "Rule_ID",
      Cell: (props) => {
        return (
          <Button onClick={() => removeCheckPoint(props.value)}>Remove</Button>
        );
      },
    },
  ];

  function ruleCheckPointData() {
    axios.post(requests.ruleCheckPoint_table_url).then((res) => {
      // console.log(res.data.body);
      setRuleCheckPoint(res.data.body);
    });
  }
  function rulelistData(checkpoint_id, invert) {
    axios
      .post(requests.rulelist_table_url, {
        checkpoint_id: checkpoint_id,
        invert: invert,
      })
      .then((res) => {
        setRulelist(res.data.body);
      });
  }

  function rulelistTableData(checkpoint_id, invert) {
    axios
      .post(requests.rulelist_table_url, {
        checkpoint_id: checkpoint_id,
        invert: invert,
      })
      .then((res) => {
        setTableData(res.data.body.reverse());
      });
  }

  function addCheckPoint() {
    setIsLoading(true);
    axios
      .post(requests.rulecheckpointstep_url, {
        rule_id: selectedRuleID.toString(),
        title: title,
        checkpoint_id: checkpoint,
      })
      .then((res) => {
        toast.success(res.data.body);
        rulelistTableData(checkpointTarget, 0);
        // setTabl=eData(res.data.body);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function removeCheckPoint(id_val) {
    console.log(checkpoint);
    setIsLoading(true);
    axios
      .post(requests.removeCheckpointstep_url, {
        rule_id: id_val,
        checkpoint_id: checkpoint ? checkpoint : 0,
      })
      .then((res) => {
        toast.success(res.data.body);
        rulelistTableData(checkpointTarget, 0);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    ruleCheckPointData();
    rulelistData(0, 0);
    rulelistTableData(0, 0);
  }, []);

  const handleChangeCheckpoint = (event) => {
    rulelistData(parseInt(event.target.value), 1);
    rulelistTableData(parseInt(event.target.value), 0);
    setCheckpointTarget(parseInt(event.target.value));
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Container className="form-container">
          <Box className="divRuleContainer divRuleContainerRCP">
            <Grid container spacing={3}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <TextField
                  className="formControl"
                  select
                  label="Module"
                  variant="outlined"
                  onChange={(event) => {
                    handleChangeCheckpoint(event);
                    setCheckpoint(event.target.value);
                  }}
                >
                  {ruleCheckPoint.map((opt) => (
                    <MenuItem key={opt.Checkpoint_ID} value={opt.Checkpoint_ID}>
                      {opt.Title}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <TextField
                  className="formControl"
                  label="Display Title"
                  value={title}
                  variant="outlined"
                  onChange={(e) => setTitle(e.target.value)}
                ></TextField>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <TextField
                  className="formControl"
                  select
                  name=""
                  label="Unassigned Rules"
                  variant="outlined"
                  onChange={(e) => setSelectedRuleID(e.target.value)}
                >
                  {rulelist.map((opt) => (
                    <MenuItem key={opt.Rule_ID} value={opt.Rule_ID}>
                      {opt.RuleTitle_CR}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addCheckPoint}
                >
                  Add
                </Button>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Box className="checkpointTable">
                  <TableContainer columns={columns} data={tableData} />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </form>
      {isLoading ? (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      ) : (
        ""
      )}
    </>
  );
}

export default RuleCheckPoint;
